import React, { useEffect } from "react";
import "./Modules.modules.css";
import { useQuery } from "react-query";
import { Link, useLocation, useNavigate } from "react-router-dom";
//primereact
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
//services
import { getModules } from "../../services/Modules/getModules";
//utils
import { formatCurrency } from "../../utils/formatCurrency";
import { Button } from "primereact/button";

const Modules = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const items = [
    {
      template: () => (
        <Link to={"/modules"} className="p-breadcrumb-link">
          Módulos adicionais
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };
  const { data: modules, isLoading } = useQuery({
    queryKey: ["modules"],
    queryFn: () => getModules(),
    retry: false,
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    let cardId = params.get("id");
    if (cardId && modules) {
      if (!cardId.startsWith("module-card-")) {
        cardId = `module-card-${cardId}`;
      }
      const el = document.getElementById(cardId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        el.classList.add("highlight");
        setTimeout(() => {
          el.classList.remove("highlight");
        }, 2000);
      }
    }
  }, [location, modules]);

  // useEffect(() => {
  //   if (modules) {
  //     modules.forEach((mod) => {
  //       console.log("modulo id:", mod.id);
  //     });
  //   }
  // }, [modules]);

  return (
    <>
      <div className="col-md-11 mx-auto text-center mt-3 mb-5">
        <div className="col-md-4">
          <BreadCrumb model={items} home={home} className="breadCrumb" />
        </div>
        <h1>
          Módulos adicionais <span className="text-success">Lote Mobile</span>
        </h1>
        <h5>
          Explore nossos módulos para agilizar a gestão dos seus
          empreendimentos. Com integração fácil e rápida ao seu sistema,
          aproxime-se mais dos seus clientes e reduza a inadimplência. Clique no
          módulo desejado para saber mais.
        </h5>
      </div>

      {isLoading && (
        <div className="preview container">
          <div className="row">
            {Array.from({ length: 3 }).map((a, index) => (
              <div key={index} className="col-md-11 cm-sm-12 mx-auto">
                <div className="preview-card">
                  <div className="preview-card__wrp">
                    <div className="preview-card__item">
                      <div className="preview-card__img">
                        <Skeleton width="100%" height="100%"></Skeleton>
                      </div>
                      <div className="preview-card__content">
                        <span className="preview-card__code">
                          <Skeleton width="100%" height="20px"></Skeleton>
                        </span>
                        <div className="preview-card__title">
                          {" "}
                          <Skeleton width="100%" height="20px"></Skeleton>
                        </div>
                        <div className="preview-card__text">
                          <Skeleton width="100%" height="20px"></Skeleton>
                        </div>
                        <div className="preview-card__title">
                          <Skeleton width="100%" height="20px"></Skeleton>
                        </div>
                        <div className="preview-card__button">Carregando..</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {modules && (
        <div className="preview container">
          <div className="row">
            {modules?.map((module, i) => {
              if (module.status === 1) {
                return (
                  <div
                    key={i}
                    className="col-md-11 cm-sm-12 mx-auto"
                    id={`module-card-${module.id}`}
                  >
                    <div
                      className="preview-card"
                      id={`module-card-wrp-${module.id}`}
                    >
                      <div
                        className="preview-card__wrp"
                        id={`module-card-wrp-inner-${module.id}`}
                      >
                        <div
                          className="preview-card__item"
                          id={`module-card-item-${module.id}`}
                        >
                          <>
                            <div className="preview-card__img">
                              <img
                                src={
                                  module.photo !== "uma_photo_aqui"
                                    ? module.photo
                                    : `https://i.pinimg.com/564x/f0/fd/35/f0fd35a4862eb163692443d112d29d5f.jpg`
                                }
                                alt="module"
                              />
                            </div>
                            <div className="preview-card__content">
                              <span className="preview-card__code">
                                {module.origin}
                              </span>
                              <div className="preview-card__title">
                                {module.name}
                              </div>
                              <div className="preview-card__text">
                                {module.desc}
                              </div>
                              <div className="preview-card__title">
                                {formatCurrency(module.value)}{" "}
                                <span style={{ fontSize: "0.6em" }}>/mês</span>
                              </div>
                              <Button
                                rounded
                                disabled={module.has_signeds}
                                icon={
                                  module.has_signeds ? "fa-solid fa-check" : ""
                                }
                                label={
                                  module.has_signeds
                                    ? "Contratado"
                                    : "Saiba Mais"
                                }
                                onClick={() => {
                                  navigate("details", {
                                    state: module,
                                  });
                                }}
                              />
                            </div>
                          </>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
              return <></>;
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default Modules;
